"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var maxScrollTop = exports.maxScrollTop = function maxScrollTop(dom) {
  return dom.scrollHeight - dom.clientHeight;
};
var runScroll = exports.runScroll = function runScroll(dom, offset) {
  dom.scrollTop = offset; // eslint-disable-line no-param-reassign
};